
import { useAtom } from 'jotai/react'

import { solPriceUsdAtom } from '@/stores/services'

import useFetch, { Method } from './useFetch'


export const useGetSolPriceUsd = (interval?: number) => {
  const [solPriceUsd, setSolPriceUsd] = useAtom(solPriceUsdAtom)
  const { ...rest } = useFetch(
    interval ? '/token/price/coingecko' : null,
    Method.GET,
    {
      ids: 'solana',
      vsCurrencies: 'usd'
    },
    {
      onSuccess: (data) => {
        if (data?.solana?.usd) {
          setSolPriceUsd(data?.solana?.usd)
        }
      }
    },
    undefined,
    {
      // refreshInterval: Millisecond.MINUTE_1
      refreshInterval: interval
    }
  )
  return {
    solPriceUsd,
    ...rest
  }
}

// export const useGetTokenPrice = () => {
//   return useFetch<number>(
//     '/token/price/binance',
//     Method.GET,
//     { symbols: '["BTCUSDT","ETHUSDT","BNBUSDT"]' },
//     {
//       onSuccess: (data) => {
//         console.log(data, data)
//       }
//     }
//   )
// }

